import { sendMutation } from './functions';

export const loginMutation = async (payload, dispatch) => {
  const userData = await sendMutation(
    dispatch,
    `mutation loginMutation(
      $loginInput: LoginInput!
    ){
      login(loginInput: $loginInput){
        message
        token
      }
    }`,
    'loginMutation',
    {
      loginInput: payload,
    }
  );

  return userData;
};

export const UpdateUserMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateUserMutation(
      $updateUserInput: UpdateUserInput!
    ){
      updateUser(updateUserInput: $updateUserInput){
        messages
      }
    }`,
    'updateUserMutation',
    {
      updateUserInput: payload,
    }
  );

  return res.data;
};

export const UpdateTerminalMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateTerminalsMutation(
      $updateTerminalsInput: UpdateTerminalsInput!
    ){
      updateTerminals(updateTerminalsInput: $updateTerminalsInput){
        messages
      }
    }`,
    'updateTerminalsMutation',
    {
      updateTerminalsInput: payload,
    }
  );

  return res.data;
};

export const UpdateTerminalConfigMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateTerminalConfigMutation(
      $updateTerminalConfigInput: UpdateTerminalConfigInput!
    ){
      updateTerminalConfig(updateTerminalConfigInput: $updateTerminalConfigInput){
        messages
      }
    }`,
    'updateTerminalConfigMutation',
    {
      updateTerminalConfigInput: payload,
    }
  );

  return res.data;
};

export const CreateTerminalMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation newTerminalMutation(
      $newTerminalInput: NewTerminalInput!
    ){
      createTerminal(newTerminalInput: $newTerminalInput){
        messages
      }
    }`,
    'newTerminalMutation',
    {
      newTerminalInput: payload,
    }
  );

  return res.data;
};

export const CreateFormMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation newPaymentFormMutation(
      $newPaymentFormInput: NewPaymentFormInput!
    ){
      createPaymentForm(newPaymentFormInput: $newPaymentFormInput){
        messages
      }
    }`,
    'newPaymentFormMutation',
    {
      newPaymentFormInput: payload,
    }
  );

  return res.data;
};

export const UpdateFormMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updatePaymentFormMutation(
      $updatePaymentFormInput: UpdatePaymentFormInput!
    ){
      updatePaymentForm(updatePaymentFormInput: $updatePaymentFormInput){
        messages
      }
    }`,
    'updatePaymentFormMutation',
    {
      updatePaymentFormInput: payload,
    }
  );

  return res.data;
};

export const CreateAccountMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation newAccountMutation(
      $newAccountInput: NewAccountInput!
    ){
      createAccount(newAccountInput: $newAccountInput){
        messages
      }
    }`,
    'newAccountMutation',
    {
      newAccountInput: payload,
    }
  );

  return res.data;
};

export const createWalletMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation newWalletMutation(
      $newWalletInput: NewWalletInput!
    ){
      createWallet(newWalletInput: $newWalletInput){
        messages
      }
    }`,
    'newWalletMutation',
    {
      newWalletInput: payload,
    }
  );

  return res.data;
};

export const updateWalletMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateWalletMutation(
      $updateWalletInput: UpdateWalletInput!
    ){
      updateWallet(updateWalletInput: $updateWalletInput){
        messages
      }
    }`,
    'updateWalletMutation',
    {
      updateWalletInput: payload,
    }
  );

  return res.data;
};

export const deleteWalletMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation deleteWalletsMutation(
      $ids: [Int!]!
    ){
      deleteWallets(ids: $ids){
        messages
      }
    }`,
    'deleteWalletsMutation',
    {
      ids: payload,
    }
  );

  return res.data;
};

export const createTicketMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation newTicketMutation(
      $newTicketInput: NewTicketInput!
    ){
      createTicket(newTicketInput: $newTicketInput){
        messages
      }
    }`,
    'newTicketMutation',
    {
      newTicketInput: payload,
    }
  );

  return res.data;
};

export const createNewCommentMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation createTicketCommentMutation(
      $newTicketCommentInput: NewTicketCommentInput!
    ){
      createTicketComment(newTicketCommentInput: $newTicketCommentInput){
        messages
      }
    }`,
    'createTicketCommentMutation',
    {
      newTicketCommentInput: payload,
    }
  );

  return res.data;
};

export const updateUserConfigMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateUserConfigMutation(
      $updateConfigInput: UpdateConfigInput!
    ){
      updateUserConfig(updateConfigInput: $updateConfigInput){
        messages
      }
    }`,
    'updateUserConfigMutation',
    {
      updateConfigInput: payload,
    }
  );

  return res.data;
};

export const updateProfileMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateProfileMutation(
      $updateProfileInput: UpdateProfileInput!
    ){
      updateProfile(updateProfileInput: $updateProfileInput){
        messages
      }
    }`,
    'updateProfileMutation',
    {
      updateProfileInput: payload,
    }
  );

  return res.data;
};

export const createSettlementMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation createSettlementMutation(
      $newSettlementInput: NewSettlementInput!
    ){
      createSettlement(newSettlementInput: $newSettlementInput){
        messages
      }
    }`,
    'createSettlementMutation',
    {
      newSettlementInput: payload,
    }
  );

  return res.data;
};

export const handleRegisterMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation registerAsShopOwnerMutation(
      $registerInput: RegisterInput!
    ){
      registerAsShopOwner(registerInput: $registerInput){
        messages
      }
    }`,
    'registerAsShopOwnerMutation',
    {
      registerInput: payload,
    }
  );

  return res.data;
};

export const handleActivateUserMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation activateUserMutation(
      $activateUserInput: ActivateUserInput!
    ){
      activateUser(activateUserInput: $activateUserInput){
        message
        token
      }
    }`,
    'activateUserMutation',
    {
      activateUserInput: payload,
    }
  );

  return res.data;
};

export const handleAuthenticationUserMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation authenticateUserMutation(
      $authenticateUserInput: AuthenticateUserInput!
    ){
      authenticateUser(authenticateUserInput: $authenticateUserInput){
        messages
      }
    }`,
    'authenticateUserMutation',
    {
      authenticateUserInput: payload,
    }
  );

  return res.data;
};

export const handleAuthenticateTelephoneMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation authenticateTelephoneMutation(
      $authenticateTelephoneInput: AuthenticateTelephoneInput!
    ){
      authenticateTelephone(authenticateTelephoneInput: $authenticateTelephoneInput){
        messages
      }
    }`,
    'authenticateTelephoneMutation',
    {
      authenticateTelephoneInput: payload,
    }
  );

  return res.data;
};

export const handleForgetPasswordMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation forgetPasswordMutation(
      $forgetPasswordInput: ForgetPasswordInput!
    ){
      forgetPassword(forgetPasswordInput: $forgetPasswordInput){
        messages
      }
    }`,
    'forgetPasswordMutation',
    {
      forgetPasswordInput: payload,
    }
  );

  return res;
};

export const handleCompleteTransactionMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation completeTransactionMutation(
      $completeTransactionInput: CompleteTransactionInput!
    ){
      completeTransaction(completeTransactionInput: $completeTransactionInput){
        messages
      }
    }`,
    'completeTransactionMutation',
    {
      completeTransactionInput: payload,
    }
  );

  return res;
};

export const cancelSettlementMutation = async (ids, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation cancelSettlementMutation($ids: [Int!]!){
      cancelSettlement(ids: $ids){
        messages
      }
    }`,
    'cancelSettlementMutation',
    {
      ids,
    }
  );

  return res.data;
};

export const handleLoginStepTwoMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation verifyTFAMutation(
      $verifyTfaInput: VerifyTfaInput!
    ){
      verifyTFA(verifyTfaInput: $verifyTfaInput){
        message
        token
      }
    }`,
    'verifyTFAMutation',
    {
      verifyTfaInput: payload,
    }
  );

  return res;
};

export const readNotificationMutation = async (notificationId) => {
  const res = await sendMutation(
    false,
    `mutation readNotificationMutation($notificationId: Float!){
      readNotification(notificationId: $notificationId){
        messages
      }
    }`,
    'readNotificationMutation',
    {
      notificationId,
    }
  );
  return res.data;
};

export const ChargeSimpleMessageWalletMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation ChargeSimpleMessageWalletMutation(
      $chargeSimpleMessageWalletInput: ChargeSimpleMessageWalletInput!
    ){
      chargeSimpleMessageWallet(chargeSimpleMessageWalletInput: $chargeSimpleMessageWalletInput){
        messages
      }
    }`,
    'ChargeSimpleMessageWalletMutation',
    {
      chargeSimpleMessageWalletInput: payload,
    }
  );

  return res;
};

export const verifyMessageChargeMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation verifyMessagingChargeMutation(
      $verifyChargeTransactionInput: VerifyChargeTransactionInput!
    ){
      verifyChargeTransaction(verifyChargeTransactionInput: $verifyChargeTransactionInput){
        messages
      }
    }`,
    'verifyMessagingChargeMutation',
    {
      verifyChargeTransactionInput: payload,
    }
  );

  return res;
};

export const sendIbanInquiryForInActiveUsersMutation = async (
  merchantIban,
  wallet
) => {
  const res = await sendMutation(
    false,
    `mutation ibanInquiryForInActiveUsers($merchantIban: String!,$walletId:Int!){
      ibanInquiryForInActiveUsers(merchantIban: $merchantIban,walletId:$walletId){
        message
        statusCode
        ibanInquiry{
          firstName
          lastName
          bankName
        }
      }
    }`,
    'ibanInquiryForInActiveUsers',
    {
      merchantIban,
      walletId: parseInt(wallet),
    }
  );
  return res.data;
};

export const transferMoneyMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation transferMoneyMutation(
      $transferBetweenWalletsInput: TransferBetweenWalletsInput!
    ){
      transferMoney(transferBetweenWalletsInput: $transferBetweenWalletsInput){
        messages
      }
    }`,
    'transferMoneyMutation',
    {
      transferBetweenWalletsInput: payload,
    }
  );

  return res;
};

export const sendPaymentFormNotificationSMSMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation sendPaymentFormNotificationSMSMutation(
      $paymentFormSMSInput: PaymentFormSMSInput!
    ){
      sendPaymentFormNotificationSMS(paymentFormSMSInput: $paymentFormSMSInput){
        messages
      }
    }`,
    'sendPaymentFormNotificationSMSMutation',
    {
      paymentFormSMSInput: payload,
    }
  );

  return res;
};

export const sendPaymentFormNotificationWhatsAppMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation sendPaymentFormNotificationWhatsApp(
      $paymentFormMessageInput: PaymentFormMessageInput!
    ){
      sendPaymentFormNotificationWhatsApp(paymentFormMessageInput: $paymentFormMessageInput){
        message
        link
      }
    }`,
    'sendPaymentFormNotificationWhatsApp',
    {
      paymentFormMessageInput: payload,
    }
  );

  return res;
};

export const createPaymentFormQRCodeMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation createPaymentFormQRCodeMutation(
      $paymentFormUrl: String!
    ){
      createPaymentFormQRCode(paymentFormUrl: $paymentFormUrl){
        message
        image
      }
    }`,
    'createPaymentFormQRCodeMutation',
    {
      paymentFormUrl: payload,
    }
  );

  return res.data;
};

export const updateApiAccessMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation ApiAccess(
      $apiAccessInput: ApiAccessInput!
    ){
      apiAccess(apiAccessInput: $apiAccessInput){
        messages
      }
    }`,
    'ApiAccess',
    {
      apiAccessInput: payload,
    }
  );

  return res;
};

export const createBranchMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation createBranch(
      $createBranchInput: CreateBranchInput!
    ){
      createBranch(createBranchInput: $createBranchInput){
        messages
      }
    }`,
    'createBranch',
    {
      createBranchInput: payload,
    }
  );

  return res;
};

export const updateBranchMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation updateBranch(
      $updateBranchInput: UpdateBranchInput!
    ){
      updateBranch(updateBranchInput: $updateBranchInput){
        messages
      }
    }`,
    'updateBranch',
    {
      updateBranchInput: payload,
    }
  );

  return res;
};

export const deleteBranchMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation deleteBranch(
      $deleteBranchInput: DeleteBranchInput!
    ){
      deleteBranch(deleteBranchInput: $deleteBranchInput){
        messages
      }
    }`,
    'deleteBranch',
    {
      deleteBranchInput: payload,
    }
  );

  return res;
};

export const changeBranchPasswordMutation = async (payload, dispatch) => {
  const res = await sendMutation(
    dispatch,
    `mutation changeBranchPassword(
      $changeBranchPasswordInput: ChangeBranchPasswordInput!
    ){
      changeBranchPassword(changeBranchPasswordInput: $changeBranchPasswordInput){
        messages
      }
    }`,
    'changeBranchPassword',
    {
      changeBranchPasswordInput: payload,
    }
  );

  return res;
};
